import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { forkJoin } from 'rxjs';
import { LoginRedirectComponent } from 'src/app/account/components/login-redirect/login-redirect.component';
import { setRedirectUrl } from 'src/app/state/redirect-url.actions';
import { selectRedirectUrl } from 'src/app/state/redirect-url.selector';
import { loadShoppingCart } from 'src/app/state/shopping-cart.actions';
import { AccountService } from './account.service';
import { ModalHelper } from './helpers/modal.helper';
import { StorageHelper } from './helpers/storage.helper';
import { ShoppingCartService } from './shopping-cart.service';

@Injectable({
  providedIn: 'root'
})
export class PostLoginService {

  redirectUrl: string;
  singletonExist = false;

  constructor(
    private router: Router,
    private accountService: AccountService,
    private storageHelper: StorageHelper,
    private store: Store,
    private modalHelper: ModalHelper,
    private shoppingCartService: ShoppingCartService
  ) { }

  processPostLoginAction() {
    this.store.pipe(select(selectRedirectUrl))
      .subscribe(result => {
        this.redirectUrl = result;
      });
    const redirect = this.redirectUrl || 'my-account';
    forkJoin([this.accountService.getUpcomingRegistration(), this.accountService.isUserAccountServiceTermActive()])
      .subscribe(
        (res) => {
          this.storageHelper.saveToSessionStorage("upcomingRegistration", JSON.stringify(res[0]?.content ? res[0].content : null));
          if (res[1].content === false) {
            this.router.navigate(['account/service-term']);
          }
          else if (res[0]?.content && res[0]?.content?.biometricConsent !== true) {
            this.router.navigate(['account/biometric-consent']);
          }
          else {
            this.loadShoppingCart();
            this.router.navigateByUrl(decodeURI(redirect));
          }
        },
      );
  }

  loadShoppingCart() {
    this.shoppingCartService.getShoppingCart()
      .subscribe(
        res => {
          this.store.dispatch(loadShoppingCart({ shoppingCart: res.content }));
        });
  }

  showLoginRedirect() {
    if (!this.singletonExist) {
      const modalRef = this.modalHelper.open(LoginRedirectComponent, this.modalHelper.getStrictModalOptions());
      this.singletonExist = true;
      this.store.dispatch(setRedirectUrl({ redirectUrl: encodeURI(this.router.url).slice(1) }));
      const componentInstance: LoginRedirectComponent = modalRef.componentInstance;
      const subscription = componentInstance.outputEvent.subscribe((val: boolean) => {
        if (val === true) {
          modalRef.close();
          this.singletonExist = false;
          this.router.navigate(['/login']);
          if (subscription) {
            subscription.unsubscribe();
          }
        }
      });
    }
  }
}
